import React, { useState, useEffect } from "react";
import AddButtonSection from '../../components/common/AddButtonSection';
import { useForm } from "react-hook-form";
import InputIterator from '../../components/common/inputIterator';
import { profileFormRender as formRender } from "../../utils/serviceData";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import { Button } from "primereact/button";
import LeftArrow from "../../assets/images/leftArrow";
import Loader from '../../components/common/loader';



const UserDetails = ({ userDetailsData, setSelectedUser }) => {
  const {
    control,
    formState: { errors, dirtyFields },
    handleSubmit,
    setValue,
  } = useForm();
  const [isEdit, setIsEdit] = useState(false);
  const [profileId, setProfileId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [profileUser, setProfileUser] = useState({});

  const onEdit = async (data) => {
    if (loader) return;
    setLoader(true);
    await commonPostApi(API_ENDPOINTS.EDIT_USER_DETAILS, {
      ...data,
      user_id: profileId,
    }).then((data) => {
      if (data?.data?.success) {
        showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.USER.UPDATED);
        searchUserDetails();
      } else {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      }
    });
  };

  const searchUserDetails = async () => {
    await commonPostApi(API_ENDPOINTS.SEARCH_USER_DETAILS, { user_id: profileId }).then(
      (data) => {
        if (data?.status === 200) {
          setSelectedUser(data?.data?.data);
          setIsEdit(false);
          getUser();
        }
        setLoader(false);
      }
    );
  };

  var buttons = [
    {
      type: "render",
      class: "col-12 p-0 pt-3",
      render: userDetailsData && (
        <div className="text-black-alpha-90 text-lg">
          {userDetailsData?.["first_name"] + " " + userDetailsData?.["last_name"]}
        </div>
      ),
    },
    {
      type: "render",
      class: "col-12 p-0 pt-3",
      render: userDetailsData?.["is_active"] && (
        <Button
          label="Active"
          severity="success"
          className="px-3 py-1 text-xs font-medium cursor-none"
        />
      ),
    },
    {
      type: "render",
      class: "col-12 p-0 pt-3",
      render: (
        <div className="msgText font-normal text-sm">
          Last logged on 2:30 pm 09-10-2024
        </div>
      ),
    },
  ];
  var button = [
    {
      type: "primarySuccessButton",
      label: "Save Changes",
      class: "w-11rem pr-3",
      disabled: Object.keys(dirtyFields).length === 0 || loader,
      onClick: handleSubmit(onEdit),
    },
    {
      type: "secondaryButton",
      label: "Cancel",
      class: "w-7rem",
      onClick: () => {
        setIsEdit(false);
      },
    },
  ];

  const editButton = [
    {
      type: "primarySuccessButton",
      label: "Edit",
      class: "md:col-1 px-2",
      onClick: () => {
        setIsEdit(true);
      },
    },
  ];

  const getUser = () => {
    if (userDetailsData) {
      setProfileId(userDetailsData?.["user_id"]);
      formRender.forEach((group) => {
        group?.item?.forEach((user) => {
          setValue(`${user?.name}`, userDetailsData[user?.name]);
          setProfileUser((prev) => ({
            ...prev,
            [user?.label]: userDetailsData[user?.name],
          }));
        });
      });
    }
  };

  useEffect(() => {
    getUser();
  }, [userDetailsData]);

  return (
    <>
      {userDetailsData ? (
        <div className="Profile Profile-container">
          <div
            className="flex align-items-center gap-2 cursor-pointer mb-4"
            onClick={() => {
              setSelectedUser(null);
            }}
          >
            <LeftArrow />
            <h3 className="font-medium m-0">User</h3>
          </div>
          <div className="Profile__card">
            <img
              style={{ height: "100px", width: "100px", borderRadius: "4px" }}
              src={
                userDetailsData?.["profile_picture"]
                  ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(userDetailsData?.user_id)}`
                  : require("../../assets/images/no-picture.jpg")
              }
              alt="profile"
            />
            <AddButtonSection buttons={buttons} />
          </div>
          {!isEdit && (
            <>
              <div className="grid">
                {Object.entries(profileUser).map(([key, value]) => (
                  <div
                    className={`${
                      key === "State" || key === "Pincode" ? "col-12" : "col-6"
                    }`}
                  >
                    <p className="Password__primary text-sm" key={key}>
                      {key}
                    </p>
                    <p className="Password__secondary text-base mb-3 mt-1 overflow-x-auto">
                      {value}
                    </p>
                  </div>
                ))}
              </div>
              <AddButtonSection disabled={loader} buttons={editButton} />
            </>
          )}
          {isEdit && (
            <>
              <InputIterator
                control={control}
                errors={errors}
                formRender={formRender}
              />
              <div className="pt-2 pl-2">
                <AddButtonSection buttons={button} />
              </div>
            </>
          )}
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default UserDetails;
